/**
 * Swiper初期化モジュール
 *
 * 各スライダーの初期化を行います。
 * 新しいスライダーを追加する場合は、このファイルに初期化コードを追加してください。
 */

/**
 * Swiperの初期化
 */
export function initSwiper() {
  // Swiperが読み込まれているか確認
  if (typeof Swiper === 'undefined') {
    console.warn('Swiper is not loaded');
    return;
  }

  // FV用スライダー
  initFvSwiper();
}

/**
 * FV用スライダーの初期化
 */
function initFvSwiper() {
  const fvSwiper = document.querySelector('.js-swiper-fv');
  if (!fvSwiper) return;

  const currentEl = document.querySelector('.js-fv-current');
  const totalEl = document.querySelector('.js-fv-total');
  const prevBtn = document.querySelector('.js-fv-prev');
  const nextBtn = document.querySelector('.js-fv-next');

  new Swiper('.js-swiper-fv', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    speed: 800,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    on: {
      init: function () {
        // 総スライド数を設定（loop時の複製スライドは除外）
        if (totalEl) {
          const realSlides = Array.from(this.slides).filter(
            (slide) => !slide.classList.contains('swiper-slide-duplicate'),
          );
          totalEl.textContent = realSlides.length;
        }
        updatePagination(this, currentEl);
      },
      slideChange: function () {
        updatePagination(this, currentEl);
      },
    },
    breakpoints: {
      768: {
        spaceBetween: 60,
      },
    },
  });

  /**
   * ページネーションの更新
   *
   * @param {Swiper} swiperInstance - Swiperインスタンス
   * @param {HTMLElement} currentElement - 現在のスライド番号を表示する要素
   */
  function updatePagination(swiperInstance, currentElement) {
    if (!currentElement) return;

    // realIndexはloopモードでも実際のスライド番号を返す
    const currentIndex = swiperInstance.realIndex + 1;
    currentElement.textContent = currentIndex;
  }
}
